export const APP_MODE_API_MODAL = "[APP_MODE] APP_MODE_API_MODAL";
